import React from 'react';
import Box from '@material-ui/core/Box';

import HorizontalImageSwiper from 'on_web/components/shared/Swiper/HorizontalImageSwiper';

import {
  qNav1Selected,
  qNav2Selected,
  qNav2NotSelected,
  qNav3Selected,
  qNav3NotSelected,
  qNav4Selected,
  qNav4NotSelected,
  qNav5Selected,
  qNav5NotSelected,
  qNav7Selected,
  qNav7NotSelected,
} from 'on_web/assets/imageList';

import {
  ROUTE_ONBOARDING_GENERAL,
  ROUTE_ONBOARDING_LIFESTYLE,
  ROUTE_ONBOARDING_DISEASES,
  ROUTE_ONBOARDING_ENVIRONMENT,
} from 'routes';

import { useTranslation } from 'react-i18next';

export default function StepProgressIndicator(props) {
  const { t } = useTranslation();

  const allItems = [
    /*{
      selectedImg: qNav1Selected,
      unselectedImg: qNav1Selected,
      text: t('common.onboardingSections.dna').toUpperCase(),
      link: props.selectedSlideIx > 0 ? ROUTE_ONBOARDING_DNA : '#',
      showInBasic: true && process.env.REACT_APP_HIDE_DNA_SECTION !== 'true',
    },*/
    {
      selectedImg: qNav2Selected,
      unselectedImg: qNav2NotSelected,
      text: t('common.onboardingSections.general').toUpperCase(),
      link: props.selectedSlideIx >= 0 ? ROUTE_ONBOARDING_GENERAL : '#',
      showInBasic: true,
    },
    {
      selectedImg: qNav3Selected,
      unselectedImg: qNav3NotSelected,
      text: t('common.onboardingSections.lifestyle').toUpperCase(),
      link: props.selectedSlideIx >= 1 ? ROUTE_ONBOARDING_LIFESTYLE : '#',
      showInBasic: true,
    },
    {
      selectedImg: qNav4Selected,
      unselectedImg: qNav4NotSelected,
      text: t('common.onboardingSections.diseases').toUpperCase(),
      link: props.selectedSlideIx >= 2 ? ROUTE_ONBOARDING_DISEASES : '#',
      showInBasic: true,
    },
    {
      selectedImg: qNav7Selected,
      unselectedImg: qNav7NotSelected,
      text: t('common.onboardingSections.environment').toUpperCase(),
      link: props.selectedSlideIx >= 3 ? ROUTE_ONBOARDING_ENVIRONMENT : '#',
      showInBasic: true,
    },
  ];

  return (
    <Box justifyContent="center" display="flex">
      <HorizontalImageSwiper
        uid={'navigation-swiper'}
        selectedSlideIx={props.selectedSlideIx}
        firstStep={props.firstStep}
        slideClassName={'q-nav-swiper-slide'}
        items={
          props.showBasicQuestions === true
            ? allItems.filter(item => item.showInBasic === true)
            : allItems
        }
      />
    </Box>
  );
}
